<template>
  <div id="app" v-cloak>
    <b-header></b-header>
    <router-view />
    <Footer></Footer>
  </div>
</template>

<script>
import BHeader from '@/components/BHeader'
import Footer from '@/components/footer'
export default {
  name: 'app',
  components: { BHeader, Footer },
  mounted: function () {},
  methods: {},
}
</script>

<style>
#app {
  font-family: '微软雅黑';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /*background-color: #f9f9f9;*/
}
body {
  margin: 0;
}
a:active,
a:hover,
a:link,
a:visited {
  outline: 0;
}
.swiper-container .swiper-wrapper {
  justify-content: space-between;
}
</style>
 